import React from 'react';

/**
 * THE segmented control (2026-10-27, the timesheets phone sheet — owner chose the boxed
 * "Team | Mine" look over underline tabs): a bordered box split into equal parts, the
 * chosen part filled blue. For a SMALL single choice inside a form or sheet; a page's
 * own view switch is still `ui/Tabs`. ⚠️ Not `ui/Toolbar`'s `TOOLBAR_SEGMENT_*` (a tinted
 * track with pills, for a TOOLBAR); this is the full-width form-field version, filled blue as mocked.
 *
 * `options` = [{ id, label }], `value`, `onChange(id)`. A `radiogroup` of `radio`
 * buttons (arrow keys are the browser's Tab order here — each part is a plain button).
 */
export default function SegmentedControl({ options, value, onChange, ariaLabel, testId }) {
  return (
    <div role="radiogroup" aria-label={ariaLabel} data-testid={testId}
      className="flex w-full overflow-hidden rounded-lg border border-gray-300 dark:border-gray-600">
      {options.map((o, i) => {
        const on = o.id === value;
        return (
          <button key={o.id} type="button" role="radio" aria-checked={on}
            data-testid={testId ? `${testId}-${o.id}` : undefined}
            onClick={() => { if (!on) onChange(o.id); }}
            className={`min-h-[44px] flex-1 px-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500 ${
              i > 0 ? 'border-l border-gray-300 dark:border-gray-600' : ''} ${
              on ? 'bg-blue-600 text-white dark:bg-blue-800 dark:text-white'
                : 'bg-transparent text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700'}`}>
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
